import {
  getSite,
  isAntena3,
  isLaRazon,
  isLaSexta,
  isOndaCero
} from 'constants/sites';
import { isPreEnv } from 'core/constants';

const replaceSitePreUrl = path => {
  const site = getSite();
  if (isOndaCero(site)) {
    return path.replace('www.ondacero.es', 'ondacero.antena3tv.es');
  }
  if (isLaSexta(site)) {
    return path.replace('www.lasexta.com', 'weblasexta.antena3tv.es');
  }
  if (isLaRazon(site)) {
    return path.replace('www.larazon.es', 'pre.larazon.es');
  }
  if (isAntena3(site)) {
    return path.replace('www.antena3.com', 'webantena3.antena3tv.es');
  }
  return path;
};

export const getPathFromPlaceAndType = (place, type, properties) => {
  const { year } = properties.elections;
  const site = getSite();
  let siteUrl = properties.sites[site].paths[type];

  if (!siteUrl) {
    return '';
  }

  if (isPreEnv) {
    siteUrl = replaceSitePreUrl(siteUrl);
  }

  // if (window.location.hostname.includes('amp.')) {
  //   siteUrl = siteUrl.replace('www.', 'amp.');
  // }

  // if (isLaRazon(site) && window.location.search.includes('outputType=amp')) {
  //   // remove last slash from url
  //   const newUrlLR = siteUrl.substring(0, siteUrl.length - 1);
  //   siteUrl = `${newUrlLR}?outputType=amp`;
  // }

  if (document.location.hash.includes('amp')) {
    siteUrl = isLaRazon(site)
      ? `${siteUrl}?outputType=amp`
      : siteUrl.replace('www.', 'amp.');
  }

  let regionName;
  let provinceName;
  let townName;

  const pathSplit = place.path.split('/');

  if (place.typePlace === 'REGION') {
    // regionName = place.path.split('/').at(-1);
    regionName = pathSplit[pathSplit.length - 1];
  } else if (place.typePlace === 'PROVINCE') {
    // provinceName = place.path.split('/').at(-1);
    provinceName = pathSplit[pathSplit.length - 1];
    // regionName = place.path.split('/').at(-2);
    regionName = pathSplit[pathSplit.length - 2];
  } else if (place.typePlace === 'TOWN') {
    // townName = place.path.split('/').at(-1);
    townName = pathSplit[pathSplit.length - 1];
    // provinceName = place.path.split('/').at(-2);
    provinceName = pathSplit[pathSplit.length - 2];
    // regionName = place.path.split('/').at(-3);
    regionName = pathSplit[pathSplit.length - 3];
  }

  const provOrComm = () => {
    if (townName) {
      return `_${provinceName}`;
    }
    if (provinceName) {
      return `-${provinceName}`;
    }
    return `-${regionName}`;
  };

  return (
    siteUrl
      // COMMON
      .replace('##placeName##', pathSplit[pathSplit.length - 1])
      .replace('##ineId##', place.ineId)
      .replace('##year##', year)
      // LA RAZÓN
      .replace('##communityNameBar##', regionName ? `/${regionName}` : '')
      .replace('##provinceNameBar##', provinceName ? `/${provinceName}` : '')
      .replace('##townNameBar##', townName ? `/${townName}` || '' : '')
      // ONDACERO
      .replace('##townNameLine##', townName ? `-${townName}` || '' : '')
      .replace('##provOrCommLineOrDownLine##', provOrComm())
  );
};
